import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkStepperModule } from '@angular/cdk/stepper';

import { McRAIHorizontalStepper, McRAIStep, McRAIStepper } from './components/stepper';
import { StepperNextButtonDirective, StepperPrevButtonDirective } from './directives/stepper-button.directive';
import { McRAIStepLabel } from './directives/step-label.directive';
import { McRAIButtonModule } from '../button/button.module';
import { StepHeaderComponent } from './components/step-header/step-header.component';

@NgModule({
  imports: [
    CommonModule,
    CdkStepperModule,
    McRAIButtonModule
  ],
  declarations: [
    McRAIStep,
    McRAIStepper,
    McRAIHorizontalStepper,
    StepperNextButtonDirective,
    StepperPrevButtonDirective,
    McRAIStepLabel,
    StepHeaderComponent
  ],
  exports: [
    McRAIStep,
    McRAIStepper,
    McRAIHorizontalStepper,
    StepperNextButtonDirective,
    StepperPrevButtonDirective,
    McRAIStepLabel
  ]
})
export class McRAIStepperModule { }
